import styled from 'styled-components';
import { Text, FlexColumn } from '@make-software/tg-mini-app-ui';

export const MenuContainer = styled(FlexColumn)`
  position: absolute;
  background: #444654;
  top: 110%;
  right: -8%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  min-width: 135px;
  z-index: 10;
`;

export const MenuItem = styled(Text)<{ selected: boolean }>`
  padding: 12px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
  color: ${({ selected }) => (selected ? '#FFFFFF' : '#9B9BA5')};
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  font-family: 'Inter', sans-serif;

  &:hover {
    background: #525362;
  }
`;
